import { Component, OnInit } from '@angular/core';
import { NavigationService } from '@app/shared/services/navigation/navigation.service';
import { NavigationSection } from '@app/shared/services/navigation/navigation-section';
import { HeaderComponent } from '@components/header/header.component';
import { RouterOutlet } from '@angular/router';
import { FooterComponent } from '@components/footer/footer.component';

@Component({
  selector: 'app-main-layout',
  templateUrl: './main-layout.component.html',
  imports: [HeaderComponent, RouterOutlet, FooterComponent],
  styleUrls: ['./main-layout.component.scss']
})
export class MainLayoutComponent implements OnInit {
  public menuItems: NavigationSection[] = [];

  constructor(private navigationService: NavigationService) {}

  ngOnInit(): void {
    this.menuItems = this.navigationService.getSiteMenu();
  }
}
